module.exports = __webpack_public_path__ + "static/media/znak.d0df44b3.png";